import type { MisconceptionDefinition } from './types'

import { TAA_LEZEN_MISCONCEPTIONS } from './taa/lezen'
import { TAA_ONTLEDEN_MISCONCEPTIONS } from './taa/ontleden'
import { TAA_SOORTEN_MISCONCEPTIONS } from './taa/soorten'
import { TAA_WOORD_MISCONCEPTIONS } from './taa/woord'
import { TAA_SIGNAALWOORD_MISCONCEPTIONS } from './taa/signaalwoord'
import { TAA_ARGUMENTATIE_MISCONCEPTIONS } from './taa/argumentatie'

/**
 * TAA — Taalbegrip misconcepties (barrel).
 *
 * STATUS (juni 2026): **Phase B — kebab-canonical registry, barrel-split**.
 *
 * Deze barrel concateneert zes sub-registries onder `./taa/`:
 * - `lezen`         — tekstbegrip, kerngedachte, feit/mening, structuur, verwijswoorden (TAA-LEZEN-*)
 * - `ontleden`      — zinsontleding, onderwerp/gezegde, bijzinnen, inversie (TAA-ONT-*)
 * - `soorten`       — woordsoorten: lidwoord, bijwoord, voornaamwoord, telwoord, voegwoord, voorzetsel (TAA-SOORT-*)
 * - `woord`         — synoniem/antoniem, context, idioom (TAA-WOORD-*)
 * - `signaalwoord`  — signaalwoord-categorieën (TAA-SIGNAALWOORD)
 * - `argumentatie`  — argumenten, standpunten, tegenargumenten (TAA-ARGUMENTATIE)
 *
 * Achtergrond: de oorspronkelijke `taa.ts` (2.249 regels) liep in
 * mei 2026 een double-export corruptie op (zie `./index.ts`). De
 * splitsing per sub-domein verkleint het risico op herhaling en
 * maakt diff/review per sub-domein hanteerbaar.
 *
 * Alle IDs volgen nog steeds `MISCONCEPTION_REGISTRY_SSOT_2026.md §3`:
 * één dot tussen module-prefix en kebab-case body, geen underscores,
 * geen extra dots (`taa.<kebab-case-id>`). De publieke API blijft
 * ongewijzigd: `index.ts` importeert `TAA_MISCONCEPTIONS` uit `./taa`.
 *
 * Eventuele TAA-seeds die nog naar oude (multi-dot/legacy) tag-IDs
 * verwijzen worden door `seedConsolidator.normalizeSeedQuestion`
 * opgepikt als unknown-tag en in een latere sweep gereconcilieerd;
 * registry-correctheid is de SSOT en gaat voor seed-compatibiliteit.
 */
export const TAA_MISCONCEPTIONS: MisconceptionDefinition[] = [
  ...TAA_LEZEN_MISCONCEPTIONS,
  ...TAA_ONTLEDEN_MISCONCEPTIONS,
  ...TAA_SOORTEN_MISCONCEPTIONS,
  ...TAA_WOORD_MISCONCEPTIONS,
  ...TAA_SIGNAALWOORD_MISCONCEPTIONS,
  ...TAA_ARGUMENTATIE_MISCONCEPTIONS,
]
